<span class="badge badge-cliente-analise-mercado-status-projetado-badge badge-cliente-analise-mercado-status-projetado-badge-perdido"
    [title]="getTitle()">
    {{status.nome}}    
</span>